import { render, staticRenderFns } from "./UploadedDocumentList.vue?vue&type=template&id=64711fac&scoped=true"
import script from "./UploadedDocumentList.vue?vue&type=script&lang=js"
export * from "./UploadedDocumentList.vue?vue&type=script&lang=js"
import style0 from "./UploadedDocumentList.vue?vue&type=style&index=0&id=64711fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64711fac",
  null
  
)

export default component.exports